
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"44","viewBox":"0 0 45 44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.3094 3.74023C12.2261 3.74023 3.97607 11.9719 3.97607 22.1102C3.97607 31.2769 10.6861 38.8852 19.4494 40.2602V27.4269H14.7927V22.1102H19.4494V18.0586C19.4494 13.4569 22.1811 10.9269 26.3794 10.9269C28.3777 10.9269 30.4677 11.2752 30.4677 11.2752V15.8036H28.1577C25.8844 15.8036 25.1694 17.2152 25.1694 18.6636V22.1102H30.2661L29.4411 27.4269H25.1694V40.2602C29.4896 39.5779 33.4235 37.3737 36.2609 34.0453C39.0984 30.717 40.6525 26.4839 40.6427 22.1102C40.6427 11.9719 32.3927 3.74023 22.3094 3.74023Z","fill":"#2157A4"}})])
          )
        }
      }
    